import { Permissions } from '../../../models/enums/permissions';
import * as React from 'react';
import { useDispatch } from 'react-redux';
import { getDocumentHelper } from '../../../actions/utility-actions';
import { Button } from '../../../components/button/Button';
import { RouteStatus } from '../../models/enums/_index';
import { ShipmentActionType } from '../../models/enums/shipment-action-type';
import { ShipmentType } from '../../models/enums/shipment-type';
import * as ShipmentModels from '../../models/shipments/_index';
import { ShipmentStatus } from '../../models/enums/shipment-status';
import { HasPermission } from '../../../containers/authorization-helpers/HasPermission';

interface IProps {
    route: ShipmentModels.ShipmentRead;
}

export const ShipmentDocuments = (props: IProps) => {

    const dispatch = useDispatch();

    const hasDeliveries = () => {
        return props.route.actions.some((itm : ShipmentModels.ShipmentAction) => {
            return itm.type === ShipmentActionType.Delivery;
        });
    };

    const hasInternationStops = () => {
        return props.route.actions.some((itm : ShipmentModels.ShipmentAction) => {
            return itm.address.country !== 'US';
        });
    };

    const hasCanadianStops = () => {
        return props.route.actions.some((itm : ShipmentModels.ShipmentAction) => {
            return itm.address.country === 'CA';
        });
    };

    const downloadContainerPaperwork = async () => {        
        const req = new ShipmentModels.DocumentRoutePaperwork(props.route.id, props.route.type);
        dispatch(getDocumentHelper(req));
    };

    const downloadRequisistion = async () => {        
        const req = new ShipmentModels.DocumentRouteLoadRequisition(props.route.id, props.route.type);
        dispatch(getDocumentHelper(req));
    };

    const downloadRunlog = async () => {        
        const req = new ShipmentModels.DocumentRouteRunlog(props.route.id, props.route.type);
        dispatch(getDocumentHelper(req));
    };

    const downloadRunlogExcel = async () => {        
        const req = new ShipmentModels.DocumentRouteRunlogExcel(props.route.id, props.route.type);
        dispatch(getDocumentHelper(req));
    };

    const downloadBillOfLading = async () => {        
        const req = new ShipmentModels.DocumentRouteBillOfLading(props.route.id, props.route.type);
        dispatch(getDocumentHelper(req));
    };

    const downloadCommercialInvoices = async () => {        
        const req = new ShipmentModels.DocumentRouteCommercialInvoices(props.route.id, props.route.type);
        dispatch(getDocumentHelper(req));
    };

    const downloadCommercialInvoiceExport = async () => {        
        const req = new ShipmentModels.DocumentRouteCommercialInvoiceExport(props.route.id, props.route.type);
        dispatch(getDocumentHelper(req));
    };

    const downloadLoadsheet = async () => {        
        const req = new ShipmentModels.DocumentRouteLoadsheet(props.route.id, props.route.type);
        dispatch(getDocumentHelper(req));
    };

    const downloadDeliverySchedule = async () => {        
        const req = new ShipmentModels.DocumentRouteDeliverySchedule(props.route.id, props.route.type);
        dispatch(getDocumentHelper(req));
    };    

    const downloadScanReport = async () => {        
        const req = new ShipmentModels.DocumentRouteScanReport(props.route.id, props.route.type);
        dispatch(getDocumentHelper(req));
    };    

    const downloadLoaderReport = async () => {        
        const req = new ShipmentModels.DocumentRouteLoaderReport(props.route.id, props.route.type);
        dispatch(getDocumentHelper(req));
    };

    return <div className="row delivery-action-buttons divider-row">        
        <div className="col-md-12">
            <h2>Documents</h2>

                <Button 
                    text="Paperwork"
                    testID="route-document-paperwork"
                    onBtnClick={ downloadContainerPaperwork } />                    

                {
                    props.route.status < RouteStatus.Closed
                        ? <React.Fragment>
                            <Button                            
                                text="Run Log"
                                testID="route-document-runlog"
                                onBtnClick={ downloadRunlog } />

                            <Button                            
                                text="Run Log (XLSX)"
                                testID="route-document-runlog"
                                onBtnClick={ downloadRunlogExcel } />
                                
                            {
                                props.route.type === ShipmentType.Container &&
                                hasDeliveries()
                                    ? <Button 
                                        text="Bill of Ladings"
                                        testID="route-document-bol"
                                        onBtnClick={ downloadBillOfLading } />
                                    : null
                            }

                            {
                                hasDeliveries() && hasInternationStops()
                                    ? <Button 
                                        text="Commercial Invoices"
                                        testID="route-document-comminv"
                                        onBtnClick={ downloadCommercialInvoices } />
                                    : null
                            }

                            {
                                hasDeliveries() && hasCanadianStops()
                                    ? <Button 
                                        text="Commercial Invoices (XLSX)"
                                        testID="route-document-comminvx"
                                        onBtnClick={ downloadCommercialInvoiceExport } />
                                    : null
                            }

                            {
                                hasDeliveries()
                                    ? <Button 
                                        text="Load Sheet"
                                        testID="route-document-loadsheet"
                                        onBtnClick={ downloadLoadsheet } />
                                    : null
                            }

                            {
                                hasDeliveries()
                                    ? <Button 
                                        text="Delivery Schedules"
                                        testID="route-document-schedules"
                                        onBtnClick={ downloadDeliverySchedule } />
                                    : null
                            }

                            {
                                props.route.type === ShipmentType.Container
                                    ? <Button 
                                        text="Load Requisition"
                                        testID="route-document-loadreq"
                                        onBtnClick={ downloadRequisistion } />
                                    : null
                            }

                            {
                                hasDeliveries()
                                    ? <Button
                                        text="Loader Report"
                                        testID="route-document-loaderreport"
                                        onBtnClick={downloadLoaderReport} />
                                    : null
                            }
                            
                        </React.Fragment>
                        : null
                }

                <HasPermission 
                    key={''} 
                    requiredPermissions={[
                        Permissions.ShippingTrucksView, Permissions.ShippingContainersView]
                    }>
                    {
                        props.route.status >= ShipmentStatus.InProduction
                            ? <Button 
                                text="Scan Report"
                                testID="route-document-scanreport"
                                onBtnClick={ downloadScanReport } />
                            : null
                    }
                </HasPermission>
        </div>
    </div>;
};
